import PropTypes from 'prop-types';
import React, { Component } from 'react'
import DownloadFailedModal from '../../../components/downloadIndicator/DownloadFailedModal'
import { connect } from 'react-redux';

export class DownloadFailedModalContainer extends Component {
    static propTypes = {
      downloadStatus: PropTypes.shape({
        failDownloadFiles: PropTypes.array.isRequired,
        countOfDownloadFailed: PropTypes.number.isRequired,
        isDownloadInProgress: PropTypes.bool.isRequired
      })
    };
  render() {
    return (
        <DownloadFailedModal 
            failDownloadsList={this.props.downloadStatus.failDownloadFiles} 
            failDownloadCount = {this.props.downloadStatus.countOfDownloadFailed}
            isDownloadInProgress = {this.props.downloadStatus.isDownloadInProgress}
        />
    )
  }
}

const mapStateToProps = state => { 
  return {
    downloadStatus: state.FileDownloadReducer,
  };
};

export default connect(
  mapStateToProps,
)(DownloadFailedModalContainer);